module.exports = __webpack_public_path__ + "static/media/pendo.b9e0f336.svg";